import React from "react";
import {Box, Button, Divider, Paper, Stack, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import BackupIcon from "@mui/icons-material/Backup";
import RestoreIcon from "@mui/icons-material/Restore";

export default function ServerBackups({ backups = [], downloading, openDialog }) {
    return (
        <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
            <Typography variant="h5" fontWeight={800}>Бэкапы</Typography>
            <Typography color="text.secondary" mb={2.5}>
                Создание, восстановление и скачивание резервных копий.
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mb={3}>
                <Button variant="contained" startIcon={<BackupIcon />} onClick={() => openDialog("backup")}>Создать</Button>
                <Button variant="outlined" startIcon={<RestoreIcon />} onClick={() => openDialog("restore")}>Восстановить</Button>
                <Button
                    variant="outlined"
                    startIcon={downloading ? <CircularProgress size={18} /> : <CloudDownloadIcon />}
                    onClick={() => openDialog("download")}
                    disabled={downloading}
                >
                    {downloading ? "Загрузка..." : "Скачать"}
                </Button>
            </Stack>

            <Divider sx={{ mb: 2 }} />
            <Typography variant="subtitle1" fontWeight={700} mb={1.5}>Последние резервные копии</Typography>

            {backups.length > 0 ? (
                <Stack spacing={1} sx={{ maxHeight: 360, overflowY: 'auto', pr: 0.5 }}>
                    {backups.map((backup, index) => (
                        <Box
                            key={`${backup.name || 'backup'}-${index}`}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                justifyContent: 'space-between',
                                gap: 0.5,
                                p: 1.5,
                                borderRadius: 2,
                                bgcolor: 'action.hover',
                            }}
                        >
                            <Typography variant="body2" fontWeight={600}>{backup.dateTime}</Typography>
                            <Typography variant="body2" color="text.secondary">{backup.sizeMb} МБ</Typography>
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Typography variant="body2" color="text.secondary">Бэкапы отсутствуют.</Typography>
            )}
        </Paper>
    );
}
